import { CodeBase } from "./_codeBase";

/** ルール区分*/
export class InputRuleDiv extends CodeBase<InputRuleDiv>
{
    /** 入力ルール区分: "01", "未指定"*/
    public static readonly NONE: InputRuleDiv = new InputRuleDiv("01", "未指定", "");

    /** 入力ルール区分: "02", "～より大きい"*/
    public static readonly GT: InputRuleDiv = new InputRuleDiv("02", "～より大きい", "");

    /** 入力ルール区分: "03", "～以上"*/
    public static readonly GTE: InputRuleDiv = new InputRuleDiv("03", "～以上", "");

    /** 入力ルール区分: "04", "～より小さい"*/
    public static readonly LT: InputRuleDiv = new InputRuleDiv("04", "～より小さい", "");

    /**入力ルール区分: "05", "～以下"*/
    public static readonly LTE: InputRuleDiv = new InputRuleDiv("05", "～以下", "");

    /** 入力ルール区分: "06", "AとBの範囲内"*/
    public static readonly BETWEEN: InputRuleDiv = new InputRuleDiv("06", "AとBの範囲内", "");

    /** 入力ルール区分: "07", "～以下"*/
    public static readonly OUT_OF_RANGE: InputRuleDiv = new InputRuleDiv("07", "AとBの範囲外", "");

    /** 入力ルール区分: "08", "整数"*/
    public static readonly INTEGER: InputRuleDiv = new InputRuleDiv("08", "整数", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): InputRuleDiv[] {
        return [
            InputRuleDiv.NONE,
            InputRuleDiv.GT,
            InputRuleDiv.GTE,
            InputRuleDiv.LT,
            InputRuleDiv.LTE,
            InputRuleDiv.BETWEEN,
            InputRuleDiv.OUT_OF_RANGE,
            InputRuleDiv.INTEGER,
        ];
    }
}